import { AsyncPipe, NgClass, NgFor, NgIf } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { IconModule, SpinnerComponent } from '@spartacus/storefront';
import { SdvorReceiptTypeTabsComponent } from './receipt-type-tabs.component';

@NgModule({
  imports: [NgIf, NgFor, AsyncPipe, NgClass, ReactiveFormsModule, SpinnerComponent, IconModule],
  declarations: [SdvorReceiptTypeTabsComponent],
  exports: [SdvorReceiptTypeTabsComponent],
})
export class SdvorReceiptTypeTabsModule {}
